import React from "react";
import * as Styled from "./styles";

const PlaceholderBody = ({ children }) => <Styled.Body>{children}</Styled.Body>;

PlaceholderBody.displayName = "Global.Entity.CollectionPlaceholder.Body";

export default PlaceholderBody;
